export const externalLinks = Object.freeze({
  bookCall: "https://calendar.app.google/K63jLqJDH4SnXi1QA",
  newsletter: "https://www.linkedin.com/build-relation/newsletter-follow?entityUrn=7428478846196367362",
  manuelLinkedIn: "https://www.linkedin.com/in/manuel-tomas-estarlich/",
  decisionAccelerator: "https://accelerator.strategicai.pro/",
  enterpriseIrelandDigitalDiscovery: "https://www.enterprise-ireland.com/aidiscovery",
  enterpriseIrelandDigitalProcessInnovation: "https://www.enterprise-ireland.com/en/supports/digital-process-innovation",
  actionIntegrityPaper: "https://github.com/mtomase/agentic-action-integrity/blob/main/research/FROM_LAYERED_CONTROLS_TO_ACTION_INTEGRITY.pdf",
  actionIntegrityEvidence: "https://github.com/mtomase/agentic-action-integrity/blob/main/research/PUBLIC_EVIDENCE_PACK.md",
  actionIntegrityArchitecture: "https://github.com/mtomase/agentic-action-integrity/tree/main/architecture",
  actionIntegrityManifest: "https://github.com/mtomase/agentic-action-integrity/blob/main/research/PUBLICATION_MANIFEST.sha256",
  actionIntegrityRepo: "https://github.com/mtomase/agentic-action-integrity",
  agenticExamplesRepo: "https://github.com/levelup360pro/agentic-ai-examples",
  agenticExamplesArchitecture: "https://github.com/levelup360pro/agentic-ai-examples/tree/main/marketing-team",
  enterpriseArchitectureRepo: "https://github.com/levelup360pro/enterprise-ai-platform-reference-architecture",
});

export function resolveLink(target) {
  return externalLinks[target] ?? target;
}

export function isExternalTarget(target) {
  return Object.hasOwn(externalLinks, target);
}
